<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"
import { computed } from "vue"

defineProps<{
  greeting?: string
  tracked_login?: {
    sign_in_count?: number
    current_sign_in_at?: string
    last_sign_in_at?: string
    current_sign_in_ip?: string
    last_sign_in_ip?: string
  }
}>()

const page = usePage<{ auth?: { role_keys?: string[] } }>()
const roleKeys = computed(() => page.props.auth?.role_keys ?? [])
const isAdmin = computed(() => roleKeys.value.includes("admin"))
</script>

<template>
  <main class="mx-auto max-w-3xl px-6 py-10">
    <h1 class="text-3xl font-semibold text-slate-900">{{ greeting ?? "Fabrik" }}</h1>

    <section class="mt-6 rounded border border-slate-200 bg-white p-5 shadow-sm">
      <h2 class="mb-3 text-lg font-medium text-slate-800">Rastreio de login</h2>
      <p class="text-sm text-slate-700">Total de logins: {{ tracked_login?.sign_in_count ?? 0 }}</p>
      <p class="text-sm text-slate-700">Login atual em: {{ tracked_login?.current_sign_in_at ?? "-" }}</p>
      <p class="text-sm text-slate-700">Login anterior em: {{ tracked_login?.last_sign_in_at ?? "-" }}</p>
      <p class="text-sm text-slate-700">IP atual: {{ tracked_login?.current_sign_in_ip ?? "-" }}</p>
      <p class="text-sm text-slate-700">IP anterior: {{ tracked_login?.last_sign_in_ip ?? "-" }}</p>
    </section>

    <section v-if="isAdmin" class="mt-6 rounded border border-slate-200 bg-white p-5 shadow-sm">
      <h2 class="mb-3 text-lg font-medium text-slate-800">Backoffice</h2>
      <div class="flex flex-wrap gap-3">
        <Link href="/companies/new" class="rounded bg-indigo-600 px-4 py-2 text-sm font-medium text-white">
          Criar empresa
        </Link>
      </div>
    </section>

    <Link
      href="/users/sign_out"
      method="delete"
      as="button"
      class="mt-6 rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white"
    >
      Sair
    </Link>
  </main>
</template>
